import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {

  showCookieContainer = false;

  public isBrowser: boolean;
  public isServer: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.cookieConsent();
      const self = this;
      setTimeout(function () {
        self.showCookieContainer = false;
      }, 130000);
    }
  }

  setCookie(name, value, days) {
    var maxAge = "";
    if (days) {
      maxAge = "; Max-Age=" + (days * 24 * 60 * 60); // sekúndur
    }

    // Ef þú vilt aðeins hafa domain þegar það er í production:
    var domain = window.location.hostname.endsWith("e-fasteignir.is")
      ? "; Domain=e-fasteignir.is"
      : "";

    document.cookie =
      name + "=" + (value || "") +
      maxAge +
      "; Path=/" +
      domain +
      "; Secure; SameSite=Lax";
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }


  eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }

  cookieConsent() {
    // Ekki sýna ef vefurinn er inni í iframe
    const isInIframe = window.self !== window.top;

    if (!isInIframe && !this.getCookie('allowCookies')) {
      this.showCookieContainer = true;
    }
  }

  cookieSamthykkja() {
    this.setCookie('allowCookies', '1', 360);
    this.showCookieContainer = false;
  }

}
